import { type WorkspaceAgentContextSourceFieldValueMentionItem } from '~/components/v2/components/workspace/workspace-agent-panel/mentions/types';
import { type ContextSourceField } from '~/components/v2/types/contextSources';

export type WorkspaceAgentBrandKitFieldValue = ContextSourceField['values'][number];

export type ToWorkspaceAgentContextSourceFieldValueMentionItemParams = {
  contextSourceId: string;
  field: ContextSourceField;
  value: WorkspaceAgentBrandKitFieldValue;
};

/**
 * One kit value as a picker row, or `null` when it is not one. Two rules, both the backend's:
 * only a `file` field's values can be referenced at all, and a value the workspace has no rendered
 * image for has nothing for the row or its preview to draw — the tab is images, not attachments.
 * An SVG or PDF logo has no `image`, so the original is what stands in for it.
 */
export const toWorkspaceAgentContextSourceFieldValueMentionItem = ({
  contextSourceId,
  field,
  value,
}: ToWorkspaceAgentContextSourceFieldValueMentionItemParams): WorkspaceAgentContextSourceFieldValueMentionItem | null => {
  if (field.valueType !== 'file') {
    return null;
  }

  const media = typeof value.value === 'object' && value.value && 'media' in value.value ? value.value.media : null;
  // `||`, not `??`: an empty-string URL would render `<img src="">` rather than fall through.
  const thumbnailUrl = media?.image || media?.original;

  if (!thumbnailUrl) {
    return null;
  }

  return {
    contextSourceFieldValueId: value.id,
    contextSourceId,
    id: value.id,
    kind: 'contextSourceFieldValue',
    thumbnailUrl,
    // The field names the slot ("Primary logo"); the value's own label names this file in it.
    title: value.label?.trim() || field.name,
  };
};
